export default __webpack_public_path__ + "images/scans_00000.05a14dc65c6186d277ea3800dfd1e637.png";